import { Component, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser, AsyncPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BcFinishedOilBlendComponent } from "../../../app-blend-calculator/bc-finished-oil-blend/bc-finished-oil-blend.component";
import { BcPredictionResultsComponent } from "../../../app-blend-calculator/bc-prediction-results/bc-prediction-results.component";
import { FavoriteManagerComponent } from '../favorite-manager/favorite-manager.component';
import { FavoriteFacadeService } from '../../../services/favorites/favorite-facade.service';
import { SharedServiceService } from '../../../services/shared-service.service';
import { PredictionExportService } from '../../../services/prediction-export.service';

@Component({
  selector: 'app-home',
  imports: [CommonModule, BcFinishedOilBlendComponent, BcPredictionResultsComponent, AsyncPipe, FavoriteManagerComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponentBC implements OnInit {
  @ViewChild(BcPredictionResultsComponent) predictionResultsComponent!: BcPredictionResultsComponent;
  hasPredictions$;

  isResizing = false;
  dividerWidth = 5;
  leftSideWidth: number = 0;
  rightSideWidth: number = 0;
  isFullscreen = false;
  showFavorites = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private sharedService: SharedServiceService,
    private exportService: PredictionExportService,
    private route: ActivatedRoute,
    private favoriteFacade: FavoriteFacadeService,
    private snackBar: MatSnackBar,
  ) {
    this.hasPredictions$ = this.sharedService.hasPredictions$;
    if (isPlatformBrowser(this.platformId)) {
      this.leftSideWidth = (window.innerWidth / 2) - (this.dividerWidth / 2);
      this.rightSideWidth = (window.innerWidth / 2) - (this.dividerWidth / 2);
    }
  }

  ngOnInit(): void {
    // Deep-link: /shareddata/:filename opens a favorite in a new tab and loads its full state.
    const filename = this.route.snapshot.paramMap.get('filename');
    if (filename) {
      this.favoriteFacade.loadSharedFavorite(filename).subscribe(result => {
        if (result.success) {
          console.log('Shared favorite loaded:', filename);
        } else {
          console.error('Shared favorite load failed:', filename, result.message);
        }
        this.showSharedFavoriteToast(result.message);
      });
    }
  }

  private showSharedFavoriteToast(message: string): void {
    this.snackBar.open(message, undefined, {
      duration: 5000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['app-snackbar'],
    });
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isResizing) {
      const offsetRight = document.body.offsetWidth - (event.clientX - this.dividerWidth / 2);
      this.leftSideWidth = event.clientX - this.dividerWidth / 2;
      this.rightSideWidth = offsetRight;
    }
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isResizing = false;
  }

  onMouseDown() {
    this.isResizing = true;
  }

  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
  }

  openFavorites(): void {
    this.showFavorites = true;
  }

  closeFavorites(): void {
    this.showFavorites = false;
  }

  /**
  * Clears the Blend 1 prediction data (UI only)
   */
  clearBlend1(): void {
    if (this.predictionResultsComponent) {
      this.predictionResultsComponent.clearBlend1();
    }
  }

  /**
  * Clears the Blend 2 prediction data (UI only)
   */
  clearBlend2(): void {
    if (this.predictionResultsComponent) {
      this.predictionResultsComponent.clearBlend2();
    }
  }

  exportPrediction(): void {
    if (!this.predictionResultsComponent) return;
    const { blend1Predictions, blend2Predictions, j300_1Details, j300_2Details } = this.predictionResultsComponent;
    this.exportService.exportPredictions(blend1Predictions, blend2Predictions, j300_1Details, j300_2Details);
  }
}

